import { h } from "preact";

import EmojiMatch from "../../apps/data/emojis/EmojiMatch";
import classname from "../../foundation/utils/classname";

import Menu from "../v2/Menu";

import styles from "./EmojiAutoCompleteList.module.css";

function renderEmojiCell(emojiMatch: EmojiMatch) {
    const {
        emoji, alias, customEmoji
    } = emojiMatch;

    const emojiPresentation = customEmoji ? (
        <img src={emoji} class={styles.emojiImg}/>
    ) : (
        <span class={classname(styles.emojiChar)}>{emoji}</span>
    );
    return (
        <div class={classname(styles.emojiItem)}>
            {emojiPresentation}
            <span class={classname(styles.emojiAlias, "body-1")}>{alias}</span>
        </div>
    );
}

interface EmojiAutoCompleteListProps {
    class?: string;
    suggestedEmojis: EmojiMatch[];
    onItemClick: (alias: string) => void;
    onClose?: () => void;
}

function EmojiAutoCompleteList({
    class: cssClass,
    suggestedEmojis,
    onItemClick,
    onClose
}: EmojiAutoCompleteListProps) {
    function handleClick(_: Event, value?: string) {
        if (value) {
            onItemClick(value);
        }
    }

    function handleClose() {
        onClose?.();
    }

    return (
        <Menu
            class={classname(styles.emojiAutoCompleteList, cssClass)}
            ignoredKeyDownEventKeys={{
                arrowRight: true,
                arrowLeft: true
            }}
            autoScrollOnVerticalNavigation
            ignoreMouseEventsOnKeyboardNavigation
            onClose={handleClose}>
            {suggestedEmojis.map(emoji => (
                <Menu.Button
                    class={styles.emojiItemWrapper}
                    key={emoji.alias}
                    value={emoji.alias}
                    checked={false}
                    onClick={handleClick}>
                    {renderEmojiCell(emoji)}
                </Menu.Button>
            ))}
        </Menu>
    );
}

export default EmojiAutoCompleteList;
